module.exports = __webpack_public_path__ + "files/e929f5d97ac36718e3a66218f45925d8.ttf";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/katex/dist/fonts/KaTeX_Size3-Regular.ttf
 ** module id = 1075
 ** module chunks = 0
 **/